const isEnterOrSpace = function isEnterOrSpace({ key }) {
  return key === 'Enter' || key === ' ';
};

export default isEnterOrSpace;
